import get from 'lodash/get';

import {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from 'views/AddProduct/types';
import ftTypes from './types';
import {
  defaultObj,
  defaultArr
} from '../utils';

const initialState = {
  updateSMFactoryProfile: {
    ...defaultObj,
  },
  smFactoryInternalNotes: {
    ...defaultArr,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypeRequest(ftTypes.UPDATE_SM_FACTORY_PROFILE): {
      return {
        ...state,
        updateSMFactoryProfile: {
          ...state.updateSMFactoryProfile,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(ftTypes.UPDATE_SM_FACTORY_PROFILE): {
      return {
        ...state,
        updateSMFactoryProfile: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(ftTypes.UPDATE_SM_FACTORY_PROFILE): {
      return {
        ...state,
        updateSMFactoryProfile: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(ftTypes.CREATE_SM_FACTORY_INTERNAL_NOTES): {
      return {
        ...state,
        smFactoryInternalNotes: {
          ...state.smFactoryInternalNotes,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(ftTypes.CREATE_SM_FACTORY_INTERNAL_NOTES): {
      return {
        ...state,
        smFactoryInternalNotes: {
          loading: false,
          data: [...state.smFactoryInternalNotes.data] || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(ftTypes.CREATE_SM_FACTORY_INTERNAL_NOTES): {
      return {
        ...state,
        smFactoryInternalNotes: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(ftTypes.GET_SM_FACTORY_INTERNAL_NOTES): {
      return {
        ...state,
        smFactoryInternalNotes: {
          ...state.smFactoryInternalNotes,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(ftTypes.GET_SM_FACTORY_INTERNAL_NOTES): {
      return {
        ...state,
        smFactoryInternalNotes: {
          loading: false,
          data: get(action, 'response.data') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(ftTypes.GET_SM_FACTORY_INTERNAL_NOTES): {
      return {
        ...state,
        smFactoryInternalNotes: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(ftTypes.UPDATE_SM_FACTORY_INTERNAL_NOTES): {
      return {
        ...state,
        smFactoryInternalNotes: {
          ...state.smFactoryInternalNotes,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(ftTypes.UPDATE_SM_FACTORY_INTERNAL_NOTES): {
      return {
        ...state,
        smFactoryInternalNotes: {
          loading: false,
          data: [...state.smFactoryInternalNotes.data] || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(ftTypes.UPDATE_SM_FACTORY_INTERNAL_NOTES): {
      return {
        ...state,
        smFactoryInternalNotes: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(ftTypes.DELETE_SM_FACTORY_INTERNAL_NOTES): {
      return {
        ...state,
        smFactoryInternalNotes: {
          ...state.smFactoryInternalNotes,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(ftTypes.DELETE_SM_FACTORY_INTERNAL_NOTES): {
      return {
        ...state,
        smFactoryInternalNotes: {
          loading: false,
          data: [...state.smFactoryInternalNotes.data] || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(ftTypes.DELETE_SM_FACTORY_INTERNAL_NOTES): {
      return {
        ...state,
        smFactoryInternalNotes: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    default:
      return state;
  }
};